"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERMISSIONS = void 0;
exports.PERMISSIONS = {
    idpConfigWrite: 'IdpConfig:write',
};
//# sourceMappingURL=Permissions.js.map